import { PressLogo } from "@/components/pullpress/PressVisuals";

export function Logo({ size = "md" }: { size?: "sm" | "md" | "lg" }) {
  return <PressLogo size={size} />;
}
